module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"heatingHeader":"Heizung","heatingAge":"Alter Heizung","lifecyclePopupTitle":"Zustand Heizung","noHeating":"Keine Heizung","years":"Jahre","yearUnknownWarning":"Alter der Wärmeerzeugung unsicher","missingHeatingType":"Heizungstyp unbekannt","heatingPower":"Heizleistung"}}')
  delete Component.options._Ctor
}
